var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-wrapper',{attrs:{"isSpinner":_vm.isSpinner}},[_vm._t("default",[_c('h2',[_vm._v("Записи разговоров")]),_c('br'),_c('div',{staticClass:"dflex"},[_c('records-filter'),_c('records-table')],1)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }